import PublishIcon from "@material-ui/icons/Publish";
import React from "react";

import { ToolbarButton } from "../dialogs/ExportDialog/ToolbarButton";
import { ProgressIcon } from "../ProgressIcon";

const ImportButton = ({ label, loading, disabled, onClick }) => (
	<ToolbarButton
		variant="text"
		disabled={disabled}
		icon={loading ? <ProgressIcon /> : <PublishIcon />}
		onClick={onClick}
	>
		{label}
	</ToolbarButton>
);

export { ImportButton as default };
